<template>
  <div>
    <top-nav :routelist="routeList"></top-nav>
    <router-view></router-view>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'

export default {
  watch: {
    '$route': 'setFirstRoute'
  },
  computed: {
    ...mapGetters(['hasPermission']),
    routeList() {
      return [
        {
          name: '任务管理',
          route: 'task_management',
          right: true,
        }
      ]
    }
  },
  methods: {
    setFirstRoute() {
      if (this.$route.name === 'task') {
        for (let item of this.routeList) {
          if (item.right) {
            this.$router.push({name: item.route})
            return
          }
        }
      }
    }
  },
  created() {
    this.setFirstRoute()
  }
}
</script>
